var __jsx = React.createElement;
import React from 'react';
import { isOk, isPending } from '@engage/result';
import { useTrack } from '@webtv/analytics/track';
import { useIsLoggedIn } from '@webtv/auth';
import { APP_VERSION_NUMBER } from '@webtv/env';
import { useSafeRouter } from '@webtv/navigation';
import { SplashPage } from '@webtv/onboarding';
import { jsx as _jsx } from "react/jsx-runtime";

var IndexPage = function IndexPage() {
  var router = useSafeRouter();

  var _useIsLoggedIn = useIsLoggedIn(),
      isLoggedIn = _useIsLoggedIn.isLoggedIn;

  var trackAnalytics = useTrack('Application Opened');
  React.useEffect(function () {
    trackAnalytics({
      referringApplication: null,
      fromBackground: null,
      appBuild: APP_VERSION_NUMBER
    }); // This should only run once for this page
    // `trackAnalytics` intentionally ommitted to avoid additional runs in the event that useTrack is updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    if (isPending(isLoggedIn)) {
      return;
    }

    if (isOk(isLoggedIn)) {
      if (isLoggedIn.value) {
        router.replace({
          pathname: '/browse',
          query: {
            categorySlug: 'featured'
          }
        });
      } else {
        router.replace('/welcome', undefined, {
          shallow: true
        });
      }
    } // We are disabling on this line because we don't want to
    // add the router object to the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isLoggedIn]);
  return /*#__PURE__*/_jsx(SplashPage, {});
};

export default IndexPage;